import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementComponent } from './components/management/management.component';
import { SharedModule } from '../shared/shared.module';
import { BackgroundTaskListComponent } from './components/background-task-list/background-task-list.component';
import { CatchUpDialogComponent } from './components/catch-up-dialog/catch-up-dialog.component';
import { MatTableModule } from '@angular/material/table';



@NgModule({
  declarations: [
    ManagementComponent,
    BackgroundTaskListComponent,
    CatchUpDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatTableModule
  ]
})
export class ManagementModule { }
